import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import loghi from '../Images/loghi.png'


export default class Footer extends React.Component {
    render() {
        return (
            <AppBar position="static" className="footer" elevation={3}>
                <div className="footer-container">
                    {/* Div per l'immagine */}
                    <div className="footer-logo">
                        <img
                            src={loghi}
                            alt="Logo"
                            className="logo-image"
                        />
                    </div>

                    {/* Div per il link */}
                    <div className="footer-link">
                        <a href="https://form.agid.gov.it/view/311e743f-580b-4583-aaf9-456b3450904e">
                            Dichiarazione d'accessibilità
                        </a>
                    </div>
                </div>
                {/* <Toolbar style={{justifyContent:'space-evenly',alignContent:'space-between',maxWidth:'100vw', backgroundColor:'#D9D9D9'}}>
                    <img src={loghi} style={{height:window.innerWidth>600?'12vh':'auto',width:window.innerWidth>500?'':'40vw'}} />                    
                </Toolbar> */}
            </AppBar>
        );
    }
}